import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'


const CustomTooltip = (props) => {
  const {
    active,
    classes,
    selectedPairs,
    showMarginValue,
    chartMeasurementUnit,
    translate
  } = props;

  if (active) {
    let limitIdx
    if (showMarginValue) {
      limitIdx = selectedPairs && selectedPairs.findIndex(x => x.value === 'Limit')
    }
    let val = (props.payload && props.payload.length) ? props.payload[0].payload.name : null
    if (val || val == 0) {
      let str = ''
      str = `${Number(val).toFixed(2)} ${translate(chartMeasurementUnit)}`
      return (
        <div className={classes.tooltip}>
          <p>{str}</p>
        </div>
      )
    }
    return null
  }

  return null
}

export default withStyles(styles)(CustomTooltip)



// WEBPACK FOOTER //
// ./src/components/common/results/views/tdnext/components/tooltip/index.js